/* Card hover media — card videos autoplay (muted, looping) so the clip is
   already running the moment the hover overlay reveals it. An
   IntersectionObserver pauses off-screen videos so a long grid doesn't
   burn battery, and a hover fallback kicks playback if the browser blocked
   autoplay. Color chips are informational only: clicking the card opens
   the product page. */
(function () {
  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function setup() {
    var vids = [].slice.call(document.querySelectorAll('video.pcard__img-alt'));
    if (!vids.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              play(en.target);
            } else {
              en.target.pause();
            }
          });
        },
        { rootMargin: '150px' }
      );
      vids.forEach(function (v) {
        io.observe(v);
      });
    } else {
      vids.forEach(play);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  /* Fallback: some browsers hold autoplay until interaction — first hover
     starts the clip. */
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.pcard');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    var v = card.querySelector('video.pcard__img-alt');
    if (v && v.paused) play(v);
  });
})();
